import React from "react"
import { TEXT_SECONDARY, GRID_LINE } from "@/constants/colors"

const STYLES = {
  axis: "flex-shrink-0 relative self-start",
  label: "absolute -bottom-5 text-[10px] whitespace-nowrap",
} as const

type TimeAxisProps = {
  label: string
  isFirst?: boolean
  alignRight?: boolean
}

const TimeAxis: React.FC<TimeAxisProps> = ({ label, isFirst = false, alignRight = false }) => (
  <div
    className={STYLES.axis}
    style={{
      width: "1px",
      height: "34px",
      backgroundColor: GRID_LINE,
      marginLeft: isFirst ? 0 : "2px",
      marginRight: alignRight ? 0 : "2px",
    }}
  >
    {label && (
      <div
        className={STYLES.label}
        style={{
          color: TEXT_SECONDARY,
          ...(alignRight ? { right: 0 } : isFirst ? { left: 0 } : { left: "50%", transform: "translateX(-50%)" }),
        }}
      >
        {label}
      </div>
    )}
  </div>
)

export default TimeAxis
